import { FormLabel } from "react-bootstrap";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ImageInput from "components/Inputs/ImageInput";

const CourseSectionImageControls = ({
  checked,
  onCheckedChange,
  image,
  onImageChange,
  mobileImage,
  onMobileImageChange,
  label = "Usar imagem no lugar dos textos desta seção",
}) => {
  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(checked)}
              onChange={(event) => onCheckedChange(event.target.checked)}
            />
          }
          label={label}
        />
      </FormGroup>

      {checked && (
        <>
          <FormLabel>
            Imagem da seção
            <ImageInput
              path={image}
              ImageChange={onImageChange}
              boxStyle={{
                width: "100%",
                maxWidth: "36rem",
                aspectRatio: "3 / 2",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </FormLabel>

          <FormLabel>
            Imagem mobile da seção
            <ImageInput
              path={mobileImage}
              ImageChange={onMobileImageChange}
              boxStyle={{
                width: "100%",
                maxWidth: "20rem",
                aspectRatio: "9 / 16",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </FormLabel>

          <div
            style={{
              width: "100%",
              maxWidth: "36rem",
              aspectRatio: "16 / 9",
              border: "1px dashed #777",
              borderRadius: "0.4rem",
              background:
                "linear-gradient(135deg, rgba(0,0,0,0.05), rgba(0,0,0,0.12))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1rem",
              textAlign: "center",
              color: "#333",
            }}
          >
            Proporções recomendadas: desktop 16:9 (1920x1080) e mobile 9:16
            (1080x1920). A seção ocupa 100% da largura e ajusta a altura pela
            proporção da imagem.
          </div>

          <span
            style={{
              padding: "0.2rem 0.4rem",
              borderRadius: "0.4rem",
              backgroundColor: "#f1f1f1",
            }}
          >
            <ErrorOutlineIcon sx={{ color: "#e6ac39" }} /> Recomendado:
            use imagem horizontal para desktop e vertical para mobile. Elas serão
            exibidas inteiras, sem cortes laterais.
          </span>
        </>
      )}
    </>
  );
};

export default CourseSectionImageControls;
